import { consignmentHistory, returnHistory, STATUSES } from 'commons';
import { Consignment, HistoryEntry, ReturnHistory, Store } from 'types';

interface checkRevokedProps {
  consignment: Consignment;
  selectedStore: Store;
}

export function checkConsignmentRevoked({
  consignment,
  selectedStore,
}: checkRevokedProps): boolean {
  return consignment.availableStores.some(availableStore => {
    if (availableStore.name === selectedStore.name) {
      return availableStore.revoked;
    }

    return false;
  });
}

function replace(value: string, args: any) {
  // Reference: https://regex101.com/r/N6Dipb/1
  return value?.replace(/\[(\w+)]/g, (_, v) => args[v] || '');
}

const DELIVERY_FAIL_TYPE = 'DELIVERY_FAIL_BY_DRIVER';

export function formatConsignmentHistoryValue(entry: HistoryEntry): string {
  const {
    type,
    observation: entryObservation,
    description,
    consignmentStatus,
  } = entry;
  const isDeliveryFailType = type === DELIVERY_FAIL_TYPE;
  const isTMSType = type.includes('TMS');
  const hasDeliveryFailureStatus =
    consignmentStatus === STATUSES.CLARIFY_DELIVERY_FAIL.value ||
    consignmentStatus === STATUSES.COLLECT_FAIL.value;

  const value =
    consignmentHistory[entry.type]?.value ||
    `Evento desconhecido (${entry.type})`;

  const message = hasDeliveryFailureStatus
    ? description
    : replace(value, entry);

  const reason =
    isDeliveryFailType && entryObservation
      ? `. Motivo: ${entryObservation}`
      : '';

  const observation =
    isTMSType && entryObservation ? `. Observação: ${entryObservation}` : '';

  return `${message}${reason}${observation}`;
}

export function formatReturnHistoryValue(entry: ReturnHistory): string {
  const { type, description, employeeName } = entry;

  if (!employeeName && (type === 'CREATED' || type === 'POST_CODE_GENERATED')) {
    const message = returnHistory[`${type}_WEB`]?.value;

    return message;
  }

  const value = returnHistory[type]?.value;
  const message =
    replace(value, entry) || description || `Evento desconhecido (${type})`;

  return message;
}
